import React from 'react';


export const Javascript = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/js.png')} />
    )
};
